<app-progress-indicator [inProgress]="isLoading"></app-progress-indicator>
<mat-tab-group [selectedIndex]="selectedIndex" (selectedTabChange)="onTabChange($event)">
  <mat-tab *ngFor="let bundesland of bundeslaenderTabs"
           [label]="bundesland.replace('Brandenburg_an_der_Havel','Brandenburg')">
    <app-unwetter-detail *ngIf="getUnwetterBundeslandFor(bundesland) as unwetter"
                         [unwetterVorhersage]="unwetter">
    </app-unwetter-detail>
    <h3 class="landkreis-header">Landkreise</h3>
    <app-unwetter-detail *ngFor="let unwetter of getUnwetterLandkreisFor(bundesland)"
                         [unwetterVorhersage]="unwetter">
    </app-unwetter-detail>
  </mat-tab>
</mat-tab-group>
